<template>
  <v-row>
    <v-col cols=6>
      <h2>{{$t('My Alerts')}}</h2>
    </v-col>
    <v-col cols=6 class="text-right mt-1">
      <v-btn
        to="/alertes/v2"
        :disabled="checkLimit"
        elevation="0"
        small
        rounded
        class="font-weight-bold"
        color="primary"
        ><v-icon small>mdi-plus</v-icon>{{$t('menu_alerts')}}</v-btn
      >
    </v-col>
    <v-col md="12" cols="12" v-if="!$vuetify.breakpoint.mobile">
      <v-simple-table dense style="max-height: 20vh">
        <thead>
          <tr>
            <th>{{$t('city_name')}}</th>
            <th>
              {{$t('alerts.alertType.temp-min')}} <br />
              (°C)
            </th>
            <th>
              {{$t('alerts.alertType.temp-max')}} <br />
              (°C)
            </th>
            <th>
              {{$t('alerts.alertType.wind')}} <br />
              (km/h)
            </th>
            <th>
              {{$t('alerts.alertType.rain-max')}} <br />
              (mm/h)
            </th>
            <th>{{$t('alerts.alertType.snow')}}</th>
            <th>{{$t('alerts.alertType.storm')}}</th>
            <th>{{$t('alerts.alertType.ice')}}</th>
            <th>{{$t('alerts.alertType.rain-now')}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(alert, i) in alerts" :key="i">
            <td
              style="cursor: pointer"
              @click="
                $router.push(`/forecasts/alerts/${alert.geoname}/${alert.name}`)
              "
            >
              <b>{{ alert.name }}</b>
            </td>
            <td>{{ getAlertConfigKey(alert.config, "temp-min") }}</td>
            <td>{{ getAlertConfigKey(alert.config, "temp-max") }}</td>
            <td>{{ getAlertConfigKey(alert.config, "wind") }}</td>
            <td>{{ getAlertConfigKey(alert.config, "rain-max") }}</td>
            <td>{{ getAlertConfigKey(alert.config, "snow") }}</td>
            <td>{{ getAlertConfigKey(alert.config, "storm") }}</td>
            <td>{{ getAlertConfigKey(alert.config, "ice") }}</td>
            <td>
              <v-icon
                v-if="getAlertConfigKey(alert.config, 'rain-now') === true"
                color="green"
                >mdi-check</v-icon
              >
              <template v-else>-</template>
            </td>
            <td>
              <!-- <v-btn icon color="primary" :to="`/alertes/v2?edit=${alert.id}`"
                ><v-icon>mdi-pen</v-icon></v-btn
              > -->
              <v-btn
                icon
                color="red"
                :loading="loading"
                @click="deleteAlert(alert.id)"
                ><v-icon>mdi-delete</v-icon></v-btn
              >
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-col>
    <v-col v-else>
      <v-row>
        <v-col cols=12 v-for="(alert, c) in alerts" :key="`c${c}`">
          <v-card>
            <v-card-title>
              {{ alert.name }}
              <v-spacer />
              <v-btn icon @click="alert.show = !alert.show"><v-icon>
              <template v-if="alert.show">
                mdi-chevron-up
              </template>
              <template v-else>
                mdi-chevron-down
              </template>
              </v-icon></v-btn>
            </v-card-title>
            <template v-if="alert.show">
            <v-card-text >
              <b
                >{{$t('alerts.alertType.temp-min')}}:
                {{ getAlertConfigKey(alert.config, "temp-min") }}°C</b
              ><br />
              <b
                >{{$t('alerts.alertType.temp-max')}}:
                {{ getAlertConfigKey(alert.config, "temp-max") }}°C</b
              ><br />
              <b>{{$t('alerts.alertType.wind')}}: {{ getAlertConfigKey(alert.config, "wind") }}km/h</b
              ><br />
              <b>{{$t('alerts.alertType.rain-max')}}: {{ getAlertConfigKey(alert.config, "rain-max") }}mm/h</b
              ><br />
              <b
                >{{$t('alerts.alertType.snow')}}:
                {{ getAlertConfigKey(alert.config, "snow") ? "Oui" : "Non" }}</b
              ><br />
              <b
                >{{$t('alerts.alertType.storm')}}:
                {{
                  getAlertConfigKey(alert.config, "storm") ? "Oui" : "Non"
                }}</b
              ><br />
              <b
                >{{$t('alerts.alertType.ice')}}:
                {{ getAlertConfigKey(alert.config, "ice") ? "Oui" : "Non" }}</b
              ><br />
              <b
                >{{$t('alerts.alertType.rain-now')}}:{{
                  getAlertConfigKey(alert.config, "rain-now") === true
                    ? "Oui"
                    : "Non"
                }}</b
              >
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                icon
                color="red"
                :loading="loading"
                @click="deleteAlert(alert.id)"
                ><v-icon>mdi-delete</v-icon></v-btn
              >
            </v-card-actions>
            </template>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col md="12" cols="12">
      <!-- export csv -->
      <v-btn
        color="primary"
        :loading="loading"
        class="rounded-pill my-2"
        elevation="0"
        @click="exportAlerts"
        v-if="!$vuetify.breakpoint.mobile && $checkLimit('alerts') > 0"
        >Export CSV</v-btn
      >

      <v-text-field rounded v-model="search" filled dense placeholder="Recherchez " />
      <v-data-table
        height="auto"
        dense
        fixed-header
        :items="alertsList"
        :headers="headers"
        :search="search"
      >
        <template v-slot:item.texte_complet="{ item }">
          <span v-html="item.texte_complet"></span>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import api from "@/api";
import { mapState } from "vuex";
export default {
  computed: {
    checkLimit() {
      let limit = this.$checkLimit("alerts");
      if (limit) {
        if (this.alerts.length >= limit) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    ...mapState(["user"]),
    headers() {
      return [
        {
          text: "Date",
          value: "date",
        },
        {
          text: "",
          value: "texte_complet",
        },
      ];
    },
  },
  data: () => ({
    alertsList: [],
    alerts: [],
    moment: moment,
    search: null,
    loading: false,
    edit: false,
  }),
  methods: {
    exportAlerts() {
      // export to csv
      let csv = 'Date;Alerte\n';
      this.alertsList.forEach((alert) => {
        // clean html tag from alert texte_complet
        alert.texte_complet = alert.texte_complet.replace(/<[^>]*>?/gm, '');
        // clean backslash n from alert texte_complet
        alert.texte_complet = alert.texte_complet.replace(/(\r\n|\n|\r)/gm, '');
        csv += `${alert.date};${alert.texte_complet}\n`;
      });
      let blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
      let url = URL.createObjectURL(blob);
      let link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'alertes.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
    },
    getAlertConfigKey(config, key) {
      let result = config.find((map) => map.key == key);
      if (!result) return "-";
      return result.bool ? result.bool : result.number;
    },
    async getUserAlerts() {
      let res = await api.alert.getMapAlerts(this.user.id_user);
      res.map(map=>map.show = false);
      this.alerts = res;
      if (this.alerts.length == 0) {
        this.$router.push("/alertes/v2");
      }
    },
    async deleteAlert(alert = this.edit) {
      this.loading = true;
      try {
        await api.alert.deleteAlert(this.user.id_user, alert);

        this.success = true;
        this.edit = null;

        this.getUserAlerts();
      } catch (err) {
        this.error = true;
      }
      this.loading = false;
    },
    async getAlerts() {
      let res = await api.alert.get(this.user.id_user);
      res.map((map) => (map.date = moment(map.date).format("DD MMM YYYY HH:mm")));
      this.$store.dispatch("setAlerts", res);
      this.alertsList = res;
    },
    async readAlerts() {
      await api.alert.readAll(this.user.id_user);
      this.getAlerts();
    },
  },
  mounted() {
    this.getAlerts();
    this.getUserAlerts();
    this.readAlerts();
  },
};
</script>

<style>
</style>